// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Timelines
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { heroEntry } from "./heroEntry";
import { abstractBg } from "./abstractBg";

// | ------------------------------------------------------------------------

gsap.registerPlugin(ScrollTrigger);

// | ------------------------------------------------------------------------

function timeline(showMarkers, timelineSection) {

  let matchMedia = gsap.matchMedia();

  const timelineItems = gsap.utils.toArray(".timeline-item");
  const timelineItemsLength = timelineItems.length;

  var timelineSection = document.querySelector(".timeline-section");
  var tl = document.querySelector(".timeline");

  var markers = showMarkers

  // Desktop version
  matchMedia.add("(min-width: 992px)", () => {

    let timelineAnimation;

    function setupTimeline() {
      // Kill existing ScrollTrigger instances to avoid duplication
      if (timelineAnimation) {
        timelineAnimation.kill();
      }

      var tlWidth = tl.offsetWidth;
      var tlMinusStart = tlWidth - 30;
      var tlOpenItemSpace = (tlMinusStart / timelineItemsLength) * 2; //600;
      var tlClosedItemSpace = (tlMinusStart - tlOpenItemSpace) / (timelineItemsLength - 1);

      let endTotal = timelineItemsLength * 450;

      timelineAnimation = gsap.timeline({
        paused: "true",
        scrollTrigger: {
          trigger: timelineSection,
          start: "center center",
          end: "+=" + endTotal + "",
          pin: ".timeline-trigger",
          markers: showMarkers,
          inertia: false,
          scrub: 1,
          snap: {
            snapTo: index => timelineItems[index],
            duration: { min: 0.25, max: 0.75 },
            delay: 0.5,
            ease: "power1.inOut",
          },
          id: "timeline-animation",
          onLeave: () => {

            var timelineSection = document.querySelector(".timeline-section");
            var ctaSection = document.querySelector(".services-cta");
            var abstractSection = document.querySelector(".about-abstract");

            if(timelineSection.classList.contains("services-timeline")){
              heroEntry(showMarkers, ctaSection);
            }

            if(abstractSection){
              abstractBg(showMarkers, abstractSection);
            }
            
          }          
        },
      });

      gsap.set(".timeline-trigger", { force3D: true });

      gsap.set(tl, {
        css: {
          gridTemplateColumns: "30px repeat(" + timelineItemsLength + ", 1fr" }
      });



      timelineItems.forEach((timelineItem, index) => {
        gsap.set(timelineItem, { width: tlClosedItemSpace + "px" });
        gsap.set(timelineItem.querySelector("p"), { opacity: 0 });

        var firstItem = timelineItems[0];
        var lastItem = timelineItems[timelineItemsLength - 1];
        var pTag = timelineItem.querySelector("p");
        var psudeo = timelineItem.querySelector("::after");

        if (timelineItem === firstItem) {
          gsap.set(timelineItem, { width: tlOpenItemSpace + "px", "--bg-position": "50% 0", "--bullet-colour": "var(--navy-black)" });
          gsap.set(pTag, { opacity: 1 });

          timelineItem.classList.add("first-item");

          timelineAnimation
            .addLabel(`snap-point${index}`)
            .to(pTag, { opacity: 0, duration: .25, force3D: true })
            .to(timelineItem, { width: tlClosedItemSpace + "px", duration: .5, "--bg-position": "0 0", force3D: true })

        } else if (timelineItem === lastItem) {
          timelineItem.classList.add("last-item");

          timelineAnimation
            .addLabel(`snap-point${index}`)
            .to(timelineItem, { width: tlOpenItemSpace + "px", duration: .5, "--bg-position": "50% 0", "--bullet-colour": "var(--navy-black)", force3D: true }, "-=0.5")
            .to(pTag, { opacity: 1, duration: .25, force3D: true })
            .to(pTag, { opacity: 1, duration: .25, force3D: true }, "+=2");

        } else {
          timelineItem.classList.add("middle-item");

          timelineAnimation
            .to(timelineItem, { width: tlOpenItemSpace + "px", duration: .5, "--bg-position": "50% 0", "--bullet-colour": "var(--navy-black)", force3D: true }, "-=0.5")
            .to(pTag, { opacity: 1, duration: .25, force3D: true })
            .addLabel(`snap-point${index}`)
            .to(pTag, { opacity: 0, duration: .25, force3D: true }, "+=2")
            .to(timelineItem, { width: tlClosedItemSpace + "px", duration: .5, "--bg-position": "0 0", force3D: true });
        }
      });
    }

    setupTimeline();

    // Restore scroll position on page load
    window.addEventListener('load', () => {
      const scrollPosition = sessionStorage.getItem('scrollPosition');
      if (scrollPosition) {
        window.scrollTo(0, parseInt(scrollPosition, 10));
        sessionStorage.removeItem('scrollPosition');
      }
    });

    // Add a resize event listener to refresh the page
    window.addEventListener('resize', () => {
      // Store the current scroll position
      sessionStorage.setItem('scrollPosition', window.scrollY);
      location.reload(); // Refresh the page on resize
    });
  })

  // Mobile version
  matchMedia.add("(max-width: 991px)", () => {

    let timelineAnimation;

    var timelineSection = document.querySelector(".timeline-section");

    timelineItems.forEach((timelineItem, index) => {
      const timelineAnimation = gsap.timeline({
        paused: "true",
        scrollTrigger: {
          trigger: timelineItem,
          start: "top center",
          end: "bottom center",
          scrub: true,
          markers: showMarkers,
          id: "timeline-animation",
          toggleActions: "play reverse none reverse",
          onEnter() {
            timelineItem.classList.add("active");
            timelineItem.classList.remove("visited");
          },
          onLeave() {
            timelineItem.classList.remove("active");
            timelineItem.classList.add("visited");
          },          
          onEnterBack() {
            timelineItem.classList.add("active");
            timelineItem.classList.remove("visited");
          },
          onLeaveBack() {
            timelineItem.classList.remove("active");
            timelineItem.classList.remove("visited");
          },
        },
      });
    });

    /*
    // Add a resize event listener to refresh the page
    window.addEventListener('resize', () => {
      if (timelineAnimation) {
        timelineAnimation.kill();
      }      
      // Store the current scroll position
      sessionStorage.setItem('scrollPosition', window.scrollY);
      location.reload(); // Refresh the page on resize
    });
    */


  });

}

export { timeline };